var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoYouTube = function SvgVideoYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#9c9da1",
    "aria-hidden": "true",
    style: {
      "--icon-color": "#9c9da1"
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.453 3.4a1.75 1.75 0 0 1 1.236 1.237c.427 1.72.4 4.974.01 6.721a1.75 1.75 0 0 1-1.237 1.237c-1.703.42-9.329.369-10.933 0a1.75 1.75 0 0 1-1.236-1.237C.89 9.718.918 6.25 1.283 4.646A1.75 1.75 0 0 1 2.52 3.41c2.276-.475 10.123-.322 10.933-.01m-6.81 2.5v4.194l3.656-2.097z"
  })));
};
export default SvgVideoYouTube;